/**
 * Ephemeral Handlers
 * Handles no-op operations for transient UI events that don't need undo/redo
 */

import type { OperationHandler } from '../types';

/**
 * Create a no-op handler for ephemeral operations
 */
function createNoOpHandler(): OperationHandler {
  return {
    undo: async () => { /* No-op */ },
    redo: async () => { /* No-op */ }
  };
}

/**
 * Register all ephemeral/no-op operation handlers
 */
export function registerEphemeralHandlers(
  handlers: Map<string, OperationHandler>
): void {
  const noOp = createNoOpHandler();

  // Drag operations (transient UI state)
  handlers.set('drag-start', noOp);
  handlers.set('drag-complete', noOp);
  handlers.set('drag-cancel', noOp);

  // Clipboard operations without actual modifications
  handlers.set('copy-nodes', noOp);
  handlers.set('cut-nodes', noOp);
}
